import { createReducer, on } from '@ngrx/store';
import { notificationsInitialState, NotificationsState } from '../states/notifications.state';
import { notificationsActions } from '../actions/notifications.actions';
import { HeaderNotification } from '@core/domain/model/notifications/notification.model';

export const notificationsReducer = createReducer(
  notificationsInitialState,
  on(
    notificationsActions.setCategory,
    (state, { category }): NotificationsState => ({
      ...state,
      currentCategory: category,
    })
  ),
  on(
    notificationsActions.setNotifications,
    (state, { notifications }): NotificationsState => ({
      ...state,
      notifications,
      error: null,
    })
  ),
  on(
    notificationsActions.errorNotifications,
    (state, { error }): NotificationsState => ({
      ...state,
      error,
      notifications: [],
    })
  ),
  on(
    notificationsActions.setCounters,
    (state, { counters }): NotificationsState => ({
      ...state,
      counters,
    })
  ),
  on(
    notificationsActions.setReadAll,
    (state): NotificationsState => ({
      ...state,
      notifications: state.notifications.map((notification) => ({ ...notification, isRead: true })),
      counters: {
        ...state.counters,
        unread: 0,
        [HeaderNotification.INVOICES]: 0,
        [HeaderNotification.PROCEDURES]: 0,
      },
    })
  ),
  on(
    notificationsActions.setReadOne,
    (state, { notificationId }): NotificationsState => ({
      ...state,
      notifications: state.notifications.map((notification) =>
        notification.id === notificationId
          ? {
              ...notification,
              isRead: true,
            }
          : notification
      ),
    })
  )
);
